"use client";
import {JSX} from "react";

import {VideoLoader} from "@/shared/ui/media";

import type {VideoTestimonialItem} from "../video-testimonials.types";

interface VideoTestimonialsSlideProps {
    video: VideoTestimonialItem;
    index: number;
    isActive: boolean;
    isPlaying: boolean;
    onPlay: (index: number) => void;
    onSlideClick: (index: number) => void;
}

export function VideoTestimonialsSlide({video, index, isActive, isPlaying, onPlay, onSlideClick}: VideoTestimonialsSlideProps): JSX.Element {
    return (
        <div
            className={`keen-slider__slide video-testimonials__slide ${isActive ? "video-testimonials__slide--active" : ""}`}
            onClick={() => onSlideClick(index)}
        >
            <div className="video-testimonials__video-wrapper">
                <VideoLoader
                    src={video.src}
                    poster={video.poster}
                    autoPlay={isPlaying || video.autoPlay}
                    loop={video.loop}
                    muted={!isPlaying}
                    controls={video.showControls}
                    showPlayButton={true}
                    onPlay={() => onPlay(index)}
                    playing={isPlaying}
                />
            </div>
        </div>
    );
}
